import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { InlineSVGComponent } from './inline-svg.component';
import { InlineSVGConfig } from './inline-svg.config';
import { InlineSVGDirective } from './inline-svg.directive';
var InlineSVGModule = (function () {
    function InlineSVGModule() {
    }
    InlineSVGModule_1 = InlineSVGModule;
    InlineSVGModule.forRoot = function (config) {
        return {
            ngModule: InlineSVGModule_1,
            providers: [
                { provide: InlineSVGConfig, useValue: config }
            ]
        };
    };
    var InlineSVGModule_1;
InlineSVGModule.ɵfac = function InlineSVGModule_Factory(t) { return new (t || InlineSVGModule)(); };
InlineSVGModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InlineSVGModule });
InlineSVGModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InlineSVGModule, [{
        type: NgModule,
        args: [{
                declarations: [InlineSVGDirective, InlineSVGComponent],
                exports: [InlineSVGDirective],
                entryComponents: [InlineSVGComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InlineSVGModule, { declarations: function () { return [InlineSVGDirective, InlineSVGComponent]; }, exports: function () { return [InlineSVGDirective]; } }); })();
    return InlineSVGModule;
}());
export { InlineSVGModule };

